import { useState, useEffect, useRef } from "react";
import { hzSwal as Swal } from "../../server/ShowAlert";
import { editItem } from "../../server/Filter";

const EditorForTitle = ({
  name,
  element,
  kind,
  id,
  placeholder,
  tag,
  onSaved,
  save,
}) => {
  const fieldValue = element?.[name] || "";
  const [value, setValue] = useState(fieldValue);
  const textareaRef = useRef(null);

  const resizeToFit = () => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  useEffect(() => {
    setValue(fieldValue);
  }, [fieldValue]);

  useEffect(() => {
    resizeToFit();
  }, [value]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = async () => {
    if (value === fieldValue) return;

    const data = {
      name: value,
    };

    try {
      if (save) {
        await save(value);
      } else {
        const kindKey = String(kind || "").replace(/^hamazon-/, "");
        await editItem(kindKey, id, data);
      }
      onSaved?.({ [name]: value });
      Swal.fire("עודכן בהצלחה!", "", "success");
    } catch (err) {
      console.error("Error updating filter:", err);
      setValue(fieldValue);
      Swal.fire("שגיאה", "עדכון הפריט נכשל", "error");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.blur();
    }
  };

  return (
    <div className="editor-for-title">
      <textarea
        ref={textareaRef}
        className={tag || ""}
        placeholder={placeholder ?? "כותרת פריט"}
        value={value}
        rows={1}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        onInput={resizeToFit}
      />
    </div>
  );
};

export default EditorForTitle;
